"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveOfferToClaim = exports.copyOfferToBuffer = exports.booking = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    booking: function booking(offerID, countryID) {
      return {
        offerID: offerID,
        countryID: countryID
      };
    },
    copyOfferToBuffer: function copyOfferToBuffer(offerID, queryID) {
      return {
        offerID: offerID,
        queryID: queryID
      };
    },
    saveOfferToClaim: function saveOfferToClaim(callbacks, params) {
      return {
        callbacks: callbacks,
        params: params
      };
    }
  }, {
    prefix: 'RESULT_BUTTONS'
  }),
  booking = exports.booking = _createActions.booking,
  copyOfferToBuffer = exports.copyOfferToBuffer = _createActions.copyOfferToBuffer,
  saveOfferToClaim = exports.saveOfferToClaim = _createActions.saveOfferToClaim;